import { render, staticRenderFns } from "./RoastCarousel.vue?vue&type=template&id=fda4fe2a&scoped=true&lang=pug"
import script from "./RoastCarousel.vue?vue&type=script&lang=js"
export * from "./RoastCarousel.vue?vue&type=script&lang=js"
import style0 from "./RoastCarousel.vue?vue&type=style&index=0&id=fda4fe2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4fe2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda4fe2a')) {
      api.createRecord('fda4fe2a', component.options)
    } else {
      api.reload('fda4fe2a', component.options)
    }
    module.hot.accept("./RoastCarousel.vue?vue&type=template&id=fda4fe2a&scoped=true&lang=pug", function () {
      api.rerender('fda4fe2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/RoastCarousel.vue"
export default component.exports